import type { SmartCreationChatStoreApi } from '@atlassian/smart-creation/smart-creation-chat-store-api';

import { useChatStore, useChatStoreActions } from '../main';

export function useSmartCreationChatStoreApi(): SmartCreationChatStoreApi {
	const [{ currentConversationId, conversations }] = useChatStore();
	const { createConversationOptimistically, setSelectedConversation, sendMessage } =
		useChatStoreActions();

	const activeConversation = conversations[currentConversationId];

	return {
		createConversationOptimistically,
		setSelectedConversation,
		activeConversationId: currentConversationId,
		activeConversation,
		sendMessage,
	};
}
